import { Button, Modal } from "@bcc-ui/ui-components";
import * as React from "react";
import { useTranslation } from "react-i18next";

import style from "./audit-log-dialog.scss";
import { AuditLogExportAllResponse } from "domain/auditLog";
import { AUDIT_LOG_EXPORT_LIMIT } from "services/audit-log/AuditLogService";
import { createDateLabel } from "utils/format";

import testIds from "testIds.json";

interface Props {
    response?: AuditLogExportAllResponse;
    totalCount: number;
    usernamePrefix?: string;
    eventType?: string;
    dateFilter?: string;
    onClose: () => void;
}

function AuditLogExportDialog(props: Props) {
    const { t } = useTranslation();
    const isLimitExceeded = props.totalCount > AUDIT_LOG_EXPORT_LIMIT;

    const formattedDate = props.dateFilter
        ? props.dateFilter
              .split(" - ")
              .map((d) => createDateLabel(d))
              .join(" - ")
        : "";

    const filterKey = [props.usernamePrefix && "username", props.eventType && "eventType", "date"]
        .filter((part): part is string => Boolean(part))
        .reduce<string>(
            (accumulator, part, index) =>
                accumulator + (index === 0 ? part : "And" + part.charAt(0).toUpperCase() + part.slice(1)),
            ""
        );

    const prefix = isLimitExceeded
        ? t("AuditLogs.export.exportingCount", { count: props.totalCount })
        : t("AuditLogs.export.inProgress");

    const message = [
        `${prefix} ${t(`AuditLogs.export.inProgressFiltered.${filterKey}`, { username: props.usernamePrefix, eventType: props.eventType, dateFilter: formattedDate, defaultValue: "" })}.`,
        isLimitExceeded ? t("AuditLogs.export.limitExceeded", { limit: AUDIT_LOG_EXPORT_LIMIT }) : undefined,
        t("AuditLogs.export.notification"),
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <Modal
            isOpen={!!props.response}
            hideModal={props.onClose}
            title={t("AuditLogs.export.title")}
            testId={testIds.common.dialog.itself}
            className={style.dialog}
            dataType="EXPORT_ALL_AUDIT_LOGS"
            buttons={
                <div className={style.centeredButton}>
                    <Button variant="Primary" onClick={props.onClose} testId={testIds.common.dialog.closeButton}>
                        {t("Common.ok")}
                    </Button>
                </div>
            }
        >
            <div>{message}</div>
        </Modal>
    );
}

export default AuditLogExportDialog;
